<template>
  <div class="page-container">
    <NavBar :data="navbarData" />
    <div class="page-content-wrapper">
      <div class="about-wrap">
        <div class="about-item h-control-1 flex">
          <div class="item-left flex">
            <div class="i-title">{{ description[0].title }}</div>
            <div class="circle-dot-warp"></div>
            <div class="vertical-line"></div>
          </div>
          <div class="i-content">
            <span>{{ description[0].content[0] }}</span>
            <span class="plus-sign">+</span>
            <span>{{ description[0].content[1] }}</span>
          </div>
        </div>
        <div class="about-item h-control-2 flex">
          <div class="item-left flex">
            <div class="i-title">{{ description[1].title }}</div>
            <div class="circle-dot-warp"></div>
            <div class="vertical-line"></div>
          </div>
          <div class="i-content">
            {{ description[1].content[0] }}<i>•</i>{{ description[1].content[1]
            }}<i>•</i>{{ description[1].content[2] }}<i>•</i
            >{{ description[1].content[3] }}
          </div>
        </div>
        <div class="about-item h-control-3 flex">
          <div class="item-left flex">
            <div class="i-title">{{ description[2].title }}</div>
            <div class="circle-dot-warp"></div>
            <div class="vertical-line"></div>
          </div>
          <div class="i-content">
            {{ description[2].content[0] }}<i>•</i
            >{{ description[2].content[1] }}
          </div>
        </div>
        <div class="about-item h-control-4 flex">
          <div class="item-left flex">
            <div class="i-title">{{ description[3].title }}</div>
            <div class="circle-dot-warp"></div>
            <div class="vertical-line"></div>
          </div>
          <div class="i-content">
            {{ description[3].content }}
          </div>
        </div>
        <div class="about-item flex">
          <div class="item-left flex">
            <div class="i-title">{{ description[4].title }}</div>
            <div class="circle-dot-warp"></div>
          </div>
          <div class="i-content">
            {{ description[4].content }}
          </div>
        </div>
      </div>
      <!-- <div class="about-container flex">
        <div class="left-container">
          <p class="title establish-title">{{ description[0].title }}</p>
          <p class="content idea-content font-16">
            {{ description[1].content[0] }}<i>•</i>{{ description[1].content[1]
            }}<i>•</i>{{ description[1].content[2] }}<i>•</i
            >{{ description[1].content[3] }}
          </p>
          <p class="title value-title">{{ description[2].title }}</p>
          <p class="content profession-content font-16">
            {{ description[3].content }}
          </p>
          <p class="title blueprint-title">{{ description[4].title }}</p>
        </div>
        <div class="principal-line-wrap">
          <p class="main-string"></p>
          <p class="circle-dot"></p>
          <p class="main-string"></p>
          <p class="circle-dot"></p>
          <p class="main-string"></p>
          <p class="circle-dot"></p>
          <p class="main-string"></p>
          <p class="circle-dot"></p>
          <p class="main-string profession"></p>
          <p class="circle-dot"></p>
          <p class="main-string blueprint"></p>
        </div>
        <div class="right-container">
          <p class="content establish-content font-16">
            {{ description[0].content[0] }}<span class="plus-sign">+</span
            >{{ description[0].content[1] }}
          </p>
          <p class="title idea-title">{{ description[1].title }}</p>
          <p class="content value-content font-16">
            {{ description[2].content[0] }}<i>•</i
            >{{ description[2].content[1] }}
          </p>
          <p class="title profession-title">{{ description[3].title }}</p>
          <p class="content blueprint-content font-16">
            {{ description[4].content }}
          </p>
        </div>
      </div> -->
    </div>
    <Footer />
    <ScrollTop />
  </div>
</template>
<script>
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import ScrollTop from "../components/scrollTop";
export default {
  name: "index",
  data() {
    return {
      navbarData: [
        { title: "首页", path: "/" },
        { title: "社区", path: "/square" },
        { title: "关于", path: "/about" },
        { title: "登录", path: "/login" },
      ],
      description: [
        {
          title: "成长",
          content: [
            "成立贵州传联网络科技有限公司， 成立于2018年8月， 是一个有朝气 、有责任 、有使命的互联网",
            "公司。",
          ],
        },
        {
          title: "理念",
          content: ["登高", "望远", "承前", "启后"],
        },
        {
          title: "价值观",
          content: ["功利千秋", "造福社会"],
        },
        {
          title: "业务",
          content:
            "我们致力于打造一个家庭信息世代传承、生活新知快乐分享、亲朋新情即时沟通的精品平台，永不停蹄的开发更新科技、使用最新理念以满足人口高速流动与高度城镇化所产生的各种需求。",
        },
        {
          title: "蓝图",
          content:
            "希望每一个人都被互联网拥抱，成为互联网的宠儿，享受互联网的快乐。在有限的生命中，为子孙后代留传宝贵的心得技艺、经验教训和未了心愿，让生命之花绽放得更精彩，生命的影响更加源远流长，生命的力量得到无限放大；希望每一个积极健康的团体，都得到互联网的呵护，使之茁壮成长。",
        },
      ],
    };
  },
  components: {
    NavBar,
    Footer,
    ScrollTop,
  },
};
</script>
<style scoped>
.page-container .header-wrapper {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 2000;
  background-color: #ffffff;
  border-bottom: solid 1px #e6e6e6;
}

.page-content-wrapper {
  width: 1200px;
  min-height: 900px;
  margin: 0 auto;
  padding-top: 61px;
  background-color: #ffffff;
}

.about-container {
  width: 900px;
  margin: 40px auto;
  justify-content: center;
}

.left-container {
  width: 300px;
  text-align: right;
}

.left-container .title,
.right-container .title {
  font-size: 18px;
  font-weight: bold;
}

.establish-title {
  margin-top: 37px;
}

.establish-content {
  margin-top: 37px;
  text-align: justify;
  line-height: 20px;
}

.idea-title {
  margin-top: 60px;
}

.idea-content {
  margin-top: 104px;
}

.idea-content i {
  margin: 0 10px;
  font-weight: bold;
}

.value-title {
  margin-top: 103px;
}

.value-content {
  margin-top: 103px;
}

.value-content i {
  margin: 0 10px;
  font-weight: bold;
}

.profession-title {
  margin-top: 104px;
}

.profession-content {
  margin-top: 103px;
  text-align: justify;
  line-height: 20px;
}

.blueprint-title {
  margin-top: 68px;
}

.blueprint-content {
  margin-top: 153px;
  text-align: justify;
  line-height: 20px;
}

.right-container {
  width: 300px;
}

.principal-line-wrap {
  display: flex;
  width: 80px;
  height: 800px;
  flex-direction: column;
  align-items: center;
  /* background-color: #e6e6e6; */
}

.main-string {
  width: 10px;
  height: 100px;
  background-color: #dcecff;
}

.main-string.profession {
  height: 150px;
}

.main-string.blueprint {
  height: 130px;
}

.principal-line-wrap .main-string:first-child {
  height: 35px;
  border-radius: 5px 5px 0 0;
}

.principal-line-wrap .main-string:last-child {
  border-radius: 0 0 5px 5px;
}

.circle-dot {
  width: 20px;
  height: 20px;
  background-color: #0074d9;
  border-radius: 50%;
}

.plus-sign {
  position: relative;
  bottom: 3px;
  margin-right: 3px;
}

.font-16 {
  font-size: 16px;
}

.about-wrap {
  padding: 200px 120px;
}

.about-item {
  position: relative;
  color: #666;
}

.h-control-1 {
  height: 122px;
}

.h-control-2 {
  height: 100px;
}

.h-control-3 {
  height: 100px;
}

.h-control-4 {
  height: 150px;
}

.about-item .item-left {
  position: relative;
  width: 116px;
  justify-content: space-between;
}

.item-left .i-title {
  font-size: 18px;
  font-weight: bold;
  line-height: 28px;
}

.vertical-line {
  position: absolute;
  top: 30px;
  right: 9px;
  width: 2px;
  background-color: #ccc;
}

.h-control-1 .item-left .vertical-line {
  height: 86px;
}

.h-control-2 .item-left .vertical-line,
.h-control-3 .item-left .vertical-line {
  height: 68px;
}

.h-control-4 .item-left .vertical-line {
  height: 116px;
}

.about-item .i-content {
  width: 650px;
  margin-left: 41px;
  font-size: 18px;
  line-height: 25px;
}

.i-content i {
  margin: 0 3px;
}

.item-left .circle-dot-warp {
  width: 18px;
  height: 26px;
  background-image: url("../assets/icon/cl_about_circle.png");
  background-position: 0 5px;
  background-repeat: no-repeat;
}

.about-item:hover {
  color: #1a70db;
}

.about-item:hover .item-left .circle-dot-warp {
  background-image: url("../assets/icon/cl_about_circle_solid.png");
}
</style>
